import languageService from '../services/LanguageService'

export const convertVersionTags = (tagIds: string[]) => tagIds.map((tagId) => ({ id: tagId, name: languageService.getTranslation('tags', tagId) }))
